import React from "react";
import Select from "react-select";

export const reportSelectStyles = {
  container: provided => ({...provided, width: "100%", minWidth: 0}),
  control: (provided, state) => ({
    ...provided,
    minHeight: 40,
    height: 40,
    borderColor: state.isFocused ? "#f5811f" : "#e5e5e5",
    borderRadius: 6,
    backgroundColor: state.isDisabled ? "#f5f5f5" : "#fff",
    boxShadow: "none",
    fontSize: "var(--font-size-label)",
    cursor: state.isDisabled ? "not-allowed" : "pointer",
    "&:hover": {
      borderColor: state.isDisabled ? "#e5e5e5" : "#f1d4c2"
    }
  }),
  valueContainer: provided => ({...provided, height: 40, padding: "0 11px"}),
  input: provided => ({...provided, margin: 0, padding: 0}),
  indicatorsContainer: provided => ({...provided, height: 40}),
  indicatorSeparator: () => ({display: "none"}),
  dropdownIndicator: provided => ({...provided, padding: "0 9px", color: "#888"}),
  singleValue: provided => ({...provided, color: "#444"}),
  placeholder: provided => ({...provided, color: "#aaa"}),
  menu: provided => ({
    ...provided,
    zIndex: 30,
    overflow: "hidden",
    border: "1px solid #e5e5e5",
    borderRadius: 6,
    boxShadow: "0 8px 24px rgba(0,0,0,.1)"
  }),
  option: (provided, state) => ({
    ...provided,
    padding: "9px 11px",
    backgroundColor: state.isSelected
        ? "#fff4e8"
        : state.isFocused
            ? "#fffaf6"
            : "#fff",
    color: state.isSelected ? "#f5811f" : "#555",
    fontSize: "var(--font-size-label)",
    cursor: "pointer"
  })
};

/** 보고서 조회조건에서 사용하는 단일 Select UI. */
export default function ReportSelect({className, ...props}) {
  return (
      <Select
          {...props}
          className={["report-select", className].filter(Boolean).join(" ")}
          styles={reportSelectStyles}
      />
  );
}
